<template>
  <div class="card-list">
    <ShadowBoxTitleDescription
      class="shadow-box"
      :title="cardListTitle"
      :isLeftText="true"
      opacity="_60"
      :addPaddingLeft="true"
    >
      <img
        v-if="shipping_type == '1'"
        src="/img/shipping_icon.png"
        class="icon"
      >
      <img
        v-if="shipping_type == '2'"
        src="/img/redeem_icon.png"
        class="icon"
      >
      <div class="card-list-container">
        <div class="scroll-container" :class="{'list-container': isList}">
          <template v-for="(cardItem, index) in cardList">
            <div class="card-container" :class="{'list': isList}" :key="index" @click="handleCardClick(cardItem)">
              <div class="image-area">
                <img
                  class="card"
                  :class="{'radius': isRadius(cardItem)}"
                  :src="cardItem.image" :alt="cardItem.card_name"
                >
                <img v-if="index === 0 && isList && page === 1" class="rank-icon-1" src="/img/rank1.png">
                <img v-if="index === 1 && isList && page === 1" class="rank-icon-2" src="/img/rank2.png">
                <img v-if="index === 2 && isList && page === 1" class="rank-icon-3" src="/img/rank3.png">
                <div class="rule_right">
                  <div v-if="cardItem.title" class="card-title">{{cardItem.title}}</div>
                  <div v-if="cardItem.action_type == 1" class="action-type">
                    {{ t('コインのみ') }}
                    <img
                    src="/img/star_coin.webp"
                    >
                  </div>
                  <div v-if="cardItem.action_type == 2" class="action-type">
                    <template v-if="cardItem.is_digital_content">
                      {{ t('ダウンロードのみ') }}
                      <img src="/img/download.png">
                    </template>
                    <template v-else>
                      {{ t('発送のみ') }}
                      <img src="/img/plane.png">
                    </template>
                  </div>
                  <div v-if="cardItem.duplication > 1" class="duplication" :class="{'with-action': cardItem.action_type > 0}">
                    <span>×{{ cardItem.duplication }}</span>
                  </div>
                </div>
                <div class="chkblock">
                  <div class="no-shipping">
                    <img
                    v-if="shipping_type == '2'"
                    src="/img/no_shipping.png"
                    >
                    <span v-if="shipping_type == '2'" class="point">
                      {{cardItem.buy_point | comma}}<span class="unit">Gem</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-info">
                <div class="card-info-right">
                  <div v-if="cardItem.shipping_schedule" class="shipping_schedule">
                    {{ cardItem.shipping_schedule }}
                  </div>
                  <div v-if="cardItem.num > 1" class="num">
                    <span >{{formatNum(cardItem.num)}}</span>
                  </div>
                </div>
                <div class="card-info-left">
                  <img v-if="cardItem.name && cardItem.name.includes('PSA')" class="psa-icon" src="/img/PSA.png">
                  <img v-if="cardItem.is_tokka == 1" class="psa-icon" src="/img/damaged.png">
                </div>
                <div class="name">
                  <span class="text">{{cardItem.name}}</span>
                </div>
                <div v-if="cardItem.rarity_label" class="rarity">
                  <span class="text">{{cardItem.rarity_label}}</span>
                </div>
                <div v-if="cardItem.rarity" class="rarity">
                  <span class="text">{{cardItem.rarity}}</span>
                </div>
                <div class="rarity">
                  <span class="text">{{cardItem.model_number}}</span>
                </div>
              </div>
              <div v-if="cardItem.is_digital_content" class="digital-content">
                <ToggleBtn
                  class="square-button download-btn"
                  :text="t('ダウンロード')"
                  :isAction="true"
                  @handleSquareBtnClick="download(cardItem)"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </ShadowBoxTitleDescription>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import ToggleBtn from '@/components/atoms/ToggleBtn.vue';

export default {
  name: 'CardList',
  mixins: [t],
  props: {
    cardListTitle: {
      type: String,
      default: '',
    },
    cardList: {
      type: Array,
      default: () => [],
    },
    isCoin: {
      type: Boolean,
      default: false,
    },
    isPoint: {
      type: Boolean,
      default: true,
    },
    shipping_type: {
      type: String,
      default: '',
    },
    isList: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  components: {
    ShadowBoxTitleDescription,
    ToggleBtn,
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },
  methods: {
    handleCardClick(cardItem) {
      this.$emit('selectCard', cardItem);
    },
    isRadius(card) {
      const specialTypes = ['2', '3', '5'];
      const isBox = card.name?.includes('BOX');
      return specialTypes.includes(String(card.card_type)) && !isBox;
    },
    formatNum(num) {
      if (!num) return null;
      const lang = this.currentUser?.language || 'ja';
      const key = '{num}枚セット';
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template.replace('{num}', num);
    },
    download(item) {
      const url = `/api/user/history/download/${item.history_id}/${item.id}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;

.card-list{
  .shadow-box {
    position: relative;
    .icon {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
    }
  }
  .card-list-container {
    display: flex;
    justify-content: center;
    margin: 10px 0;
    .scroll-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      gap: 18px;
      max-width: 660px;
      width: auto;
    }
    .card-container {
      display: flex;
      min-height: 240px;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 150px;
      padding: 30px 30px 10px;
      border-radius: 10px;
      position: relative;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
      // cursor: pointer;
      .image-area {
        .rank-icon-1 {
          z-index: 2;
          position: absolute;
          top: -20px;
          left: -25px;
          width: 60px;
          height: auto;
        }
        .rank-icon-2 {
          z-index: 2;
          position: absolute;
          top: -20px;
          left: -25px;
          width: 48px;
          height: auto;
        }
        .rank-icon-3 {
          z-index: 2;
          position: absolute;
          top: -20px;
          left: -20px;
          width: 40px;
          height: auto;
        }
        .rule_right{
          display: flex;
          flex-direction: column;
          position: absolute;
          font-weight: bold;
          align-items: flex-end;
          top: -10px;
          right: 0px;
          max-width: calc(100% - 45px);
          .card-title{
            border-radius: 5px;
            font-size: 12px;
            padding: 1px 4px;
            background-color: #fff;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
            margin-bottom: 6px;
            color: #12469b;
          }
          .action-type{
            font-size: 12px;
            display: flex;
            align-items: center;
            background-color: #fff;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
            border-radius: 5px;
            padding: 0 0 0 6px;
            img {
              height: 18px;
              width: auto;
            }
          }
          .duplication {
            font-size: 26px;
            font-weight: bold;
            color: red;
          }
        }
        .chkblock {
          position: absolute;
          top: -30px;
          left: -30px;
          img {
            width: 70px;
          }
        }
        .card {
          width: 100%;
          min-width: 113px;
          transform: rotate(10deg);
          &.radius{
            border-radius: 4px;
          }
        }
      }
      .card-info {
        line-height: 1.1;
        display: flex;
        flex-direction: column;
        align-items: center;
        // height: 66px;
        width: 150%;
        color: $gray2;
        font-weight: bold;
        background: white;
        z-index: 1;
        margin-top: -35px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
        border-radius: 10px;
        padding: 4px;
        position: relative;
        .card-info-right{
          position: absolute;
          bottom: 100%;
          right: 0;
          margin-bottom: 3px;
          font-size: 12px;
          font-weight: bold;
          display: flex;
          align-items: flex-end;
          flex-direction: column;
          .shipping_schedule{
            border-radius: 5px;
            padding: 1px 4px;
            background-color: #fff;
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
            margin-bottom: 6px;
            color: #cd151d;
          }
          .num{
            background-color: #fff;
            border-radius: 5px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
            padding: 1px 4px;
            color: #0614c3;
            z-index: 0;
          }
        }
        .card-info-left{
          position: absolute;
          bottom: 100%;
          left: -5px;
          margin-bottom: 3px;
          font-size: 12px;
          font-weight: bold;
          display: flex;
          align-items: center;
          align-items: flex-end;
          flex-direction: column;
          .psa-icon{
            width: 50px;
            height: auto;
          }
        }
        .name {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          max-height: calc(1.3em * 2); // 2行分の高さ
          width: 100%;
          text-align: center;
          // padding: 2px 1px;
        }

        .rarity {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          max-height: calc(1.3em * 1); // 2行分の高さ
          width: 100%;
          padding: 2px 1px;
          text-align: center;
          font-size: 12px;
          border-radius: 5px;
        }
      }
    }
  }
  .digital-content {
    margin-top: 5px;
    .download-btn {
      ::v-deep .v-btn.inner {
        background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6) !important;
      }
    }
  }
  @media screen and (max-width: $tabletWidth) {
    .card-list-container {
      .scroll-container {
        max-width: 494px;
      }
      .card-container {
        min-height: 145px;
        width: 110px;
        padding: 7px;
        // height: 55px;
        .image-area {
          .rank-icon-1 {
            width: 54px;
            top: -13px;
            left: -20px;
          }
          .rank-icon-2 {
            width: 48px;
            top: -13px;
            left: -20px;
          }
          .rank-icon-3 {
            width: 45px;
            top: -13px;
            left: -20px;
          }
          .rule_right{
            max-width: calc(100% - 25px);
            .card-title{
              font-size: 9px;
              padding: 1px 4px;
              margin-bottom: 2px;
            }
            .action-type{
              font-size: 9px;
              img {
                height: 16px;
              }
            }
            .duplication {
              font-size: 19px;
            }
          }
          .chkblock {
            top: -15px;
            left: -20px;
            img {
              width: 30px;
            }
          }
        }
        .card {
          width: 70px !important;
          min-width: 70px !important;
        }
        .card-info {
          width: 110%;
          .card-info-right{
            .shipping_schedule{
              font-size: 7px;
              padding: 1px 4px;
              margin-bottom: 2px;
            }
            .num{
              font-size: 11px;
              padding: 2px 5px;
              top: -18px;
            }
          }
          .psa-icon{
            width: 40px;
            top: -22px;
          }
          .name {
            font-size: 9px;
          }
          .rarity {
            span {
              font-size: 9px;
            }
          }
        }
      }
    }
    .digital-content {
      .download-btn {
        ::v-deep .text {
          font-size: 10px;
        }
      }
    }
  }
  @media screen and (max-width: 550px){
    .card-list-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .scroll-container {
          max-width: 321px;
          &.list-container {
            max-width: 337px;
          }
        }
      .card-container {
        max-width: 95px !important; // 3列に合わせる
        padding: 7px; // 余白調整
        &.list{
          max-width: 100px !important; // 3列に合わせる
        }
      }
    }

    .rank-icon-1 {
      width: 42px !important;
      top: -13px !important;
      left: -20px !important;
    }
    .rank-icon-2 {
      width: 38px !important;
      top: -13px !important;
      left: -20px !important;
    }
    .rank-icon-3 {
      width: 35px !important;
      top: -13px !important;
      left: -20px !important;
    }
  }
}

</style>
